var cursor = '_1rk7okh0';
var shadow = '_1rk7okh1';
var trigger = '_1rk7okh2';

export { cursor, shadow, trigger };
//# sourceMappingURL=scrubbable.css.js.map
